import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import "./sonner-custom.css"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-slate-900 group-[.toaster]:to-slate-800 group-[.toaster]:text-white group-[.toaster]:border group-[.toaster]:border-amber-500/30 group-[.toaster]:shadow-2xl group-[.toaster]:backdrop-blur-xl group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-slate-300",
          actionButton:
            "group-[.toast]:bg-gradient-to-r group-[.toast]:from-amber-500 group-[.toast]:to-orange-500 group-[.toast]:text-white group-[.toast]:rounded-lg",
          cancelButton:
            "group-[.toast]:bg-slate-700 group-[.toast]:text-slate-300 group-[.toast]:rounded-lg",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
